/* Happy Hemp: Purity-Warenkorb statt UpCart.
   Fast Bundle ruft nach „Bundle in den Warenkorb“ window.upcartRefreshCart() und window.upcartOpenCart() auf
   (Einstellung „cart drawer function“ in der App). Ohne UpCart übernehmen diese beiden Funktionen den
   Purity-Warenkorb: Inhalt und Zähler neu laden, dann öffnen. Ist UpCart wieder aktiv, gelten dessen Funktionen. */
import { FSProgressBar } from "@NextSkyTheme/global";
import { LazyLoader } from "@NextSkyTheme/lazy-load";
import { eventModal } from "@NextSkyTheme/modal";

const hhCartDrawer = () => document.querySelector("cart-drawer");

async function hhRefreshCart() {
  const cart = hhCartDrawer();
  if (!cart || typeof cart.getSectionsToRender !== "function") return;
  const ids = [...new Set(cart.getSectionsToRender().map((section) => section.section))];
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const response = await fetch(`${root}?sections=${ids.join(",")}`);
  if (!response.ok) return;
  cart.renderContents({ sections: await response.json() });
  // wie nach dem Hinzufügen im Theme: Gratisversand-Balken neu berechnen, Bilder nachladen
  new FSProgressBar("free-ship-progress-bar");
  new LazyLoader(".image-lazy-load");
}

function hhOpenCart() {
  const cart = hhCartDrawer();
  if (!cart) return;
  // Das Bundle-Fenster von Fast Bundle liegt über dem Warenkorb (UpCart lag darüber) – vorher über sein X schließen
  document
    .querySelectorAll('[class^="modal_container_"] [class*="modal_close_icon_wrapper_"]')
    .forEach((closeButton) => closeButton.click());
  eventModal(cart, "open", false, "delay");
}

if (typeof window.upcartRefreshCart !== "function") window.upcartRefreshCart = hhRefreshCart;
if (typeof window.upcartOpenCart !== "function") window.upcartOpenCart = hhOpenCart;
